// SCRIPT ANIMATE.JS

function LoadingScreen(){
  
  var TIMELINE = anime.timeline({
    easing: 'cubicBezier(0.420, 0.000, 0.580, 1.000)',            
  });

  TIMELINE
  .add({
    targets: ".loader-overlay",
    translateX: ['-120%', 0],
    rotate: [20, 0],
    delay: 200,
    duration: 2250,
  })
  .add({
    targets: ".loading-screen",
    translateY: '-100%',
    delay: 150,
    duration: 850,
  })  
  
};

if (sessionStorage.getItem("loader") === null) {
  
  document.querySelector('.container_website').classList.remove("hidden");
  document.querySelector('.loading-screen').classList.remove("hidden");
  
  LoadingScreen();
  
  sessionStorage.setItem('loader', 'true');
  
} else {
 
  document.querySelector('.container_website').classList.remove("hidden");
  
}